var exports = {
  "Tr": "contributorsRow__qTyZms",
  "JV": "avatarStackWrapper__26WBOH",
  "vU": "contributorsButton__IHcP7W",
  "ZT": "contributorsTitle__AwK0xe",
  "xp": "counterLabel__z4d6yr",
  "w6": "contributorDialogList__ZWWYMm",
  "YG": "contributorRow__K5TJN0",
  "qj": "contributorLink__a1RsVN",
  "ng": "contributorAvatar__J9zefo",
  "kc": "errorText__prAY_A",
};

module.exports = exports;
